import { ApiResponse, fetcher } from './base-api';
import {
  BannerListResponse,
  GetBannerListParams,
  GetStoryBannerParams,
} from './types/banner.type';
import { SiteCategory } from './types/globals.type';

// export const getBannerList = async (
//   params?: GetBannerListParams,
// ): Promise<ApiResponse<BannerEntity[]>> => {
//   return fetcher<BannerEntity[]>('/banner', { params });
// };

export const getBannerList = async (
  params?: GetBannerListParams,
): Promise<ApiResponse<BannerListResponse>> => {
  return fetcher<BannerListResponse>('/banner', {
    params: {
      ...params,
      category: SiteCategory.TRAINING,
    },
  });
};

// 스토리 배너(게시글 상세 상단) 조회
export const getStoryBanner = async (
  params?: GetStoryBannerParams,
): Promise<ApiResponse<BannerListResponse>> => {
  return fetcher<BannerListResponse>('/banner/story', {
    params: {
      ...params,
      category: SiteCategory.TRAINING,
    },
  });
};
